export default {
    obtenerSeguimiento(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Reporte/ObtenerSeguimiento`).then(response => {
            vm.opciones = response.data;
        })
    },
    insertarMovimiento(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.reporte);
        formData.append("svindice", datos.indice);

        return vm.axios.post(`${vm.domain.domainNameForApi}Reporte/ObtenerValidacionDocumentos`, formData).then(response => response.data)
    },
    GuardarMovimiento(vm, datos) {

        var formData = new FormData();
        formData.append("nrreporte", datos.reporte);
        formData.append("svindice", datos.indice);
        formData.append("ceclave", datos.ceclave.ceclave);
        formData.append("observaciones", datos.observaciones);
        return vm.axios.post(`${vm.domain.domainNameForApi}Reporte/GuardarSeguimiento`, formData).then(response => response.data)
    },
    ObtenerDocumentosValidacion(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.reporte);
        formData.append("svindice", datos.indice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Reporte/ObtenerDocumentos`, formData).then(response => response.data)
    },
    ObtenerNombreAsegurado(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.reporte);
        formData.append("svindice", datos.indice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Reporte/NombreAsegurado`, formData).then(response => response.data)
    },
    GuardarSolicitudDocumentos(vm, datos) {
        
        var formData = new FormData();
        formData.append("filefactura", datos.documentoFactura);
        formData.append("filetarjeta", datos.documentoTarjeta);
        formData.append("filecomprobante", datos.documentoComprobante);
        formData.append("filepoliza", datos.documentoPoliza);
        formData.append("fileine", datos.documentoIne);
        formData.append("nrreporte", datos.reporte);
        formData.append("svindice", datos.indice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Reporte/GuardarSolicitudDocumentos`, formData).then(response => response.data)
    },
    

    GuardarSolicitudDocumentosTenencia2(vm, datos, file, doclave) {
        
        var formData = new FormData();
        for (var i = 0; i < file.length; i++) {
            formData.append("files", file[i]);
        }
        
        formData.append("doclave", doclave);
        formData.append("nrreporte", datos.reporte);
        formData.append("svindice", datos.indice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Reporte/GuardarSolicitudDocumentosTenencia2`, formData).then(response => response.data)
    }
}